export const HIGHEST_APPROVAL_ODDS = 'Highest Approval Odds';
export const SUGGESTED = 'Suggested';
export const BALANCE_TRANSFER = 'Balance Transfer';
export const REWARDS = 'Rewards';
export const BUSINESS = 'Business';
export const TRAVEL = 'Travel';
export const CASH_BACK = 'Cash Back';
export const NO_ANNUAL_FEE = 'No Annual Fee';
export const PRE_APPROVED_CARDS = 'PRE_APPROVED_CARDS';
export const SECURED = 'Secured';

export const CATEGORY_FILTERS = {
  PRE_APPROVED_CARDS: HIGHEST_APPROVAL_ODDS,
  SUGGESTED_BEST_CARDS: SUGGESTED,
  SUGGESTED_BALANCE_TRANSFER_CARDS: BALANCE_TRANSFER,
  SUGGESTED_REWARDS_CARDS: REWARDS,
  // comment out now for https://creditsesame.atlassian.net/browse/EPOD-8886
  // SUGGESTED_BUSINESS_CARDS: BUSINESS,
  AIRLINE_CARDS: TRAVEL,
  CASH_BACK_CARDS: CASH_BACK,
  NO_ANNUAL_FEE: NO_ANNUAL_FEE,
};

export const CATEGORY_FILTERS_ABOVE650 = {
  SUGGESTED_BEST_CARDS: SUGGESTED,
  PRE_APPROVED_CARDS: HIGHEST_APPROVAL_ODDS,
  SUGGESTED_BALANCE_TRANSFER_CARDS: BALANCE_TRANSFER,
  SUGGESTED_REWARDS_CARDS: REWARDS,
  // comment out now for https://creditsesame.atlassian.net/browse/EPOD-8886
  // SUGGESTED_BUSINESS_CARDS: BUSINESS,
  AIRLINE_CARDS: TRAVEL,
  CASH_BACK_CARDS: CASH_BACK,
  NO_ANNUAL_FEE: NO_ANNUAL_FEE,
};

export const LIST_FILTERS = Object.values(CATEGORY_FILTERS);
export const LIST_FILTER_ABOVE650 = Object.values(CATEGORY_FILTERS_ABOVE650);
